import React from 'react'
import { useFFEStore } from '../../store/ffeStore'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
}

export const MaterialThumbnails: React.FC<Props> = ({ item }) => {
  const materials = useFFEStore((state) => state.document.materials)
  const setImageEditorEntity = useFFEStore(
    (state) => state.setImageEditorEntity
  )

  if (!item.materials?.length) return null

  const itemMaterials = item.materials
    .map((m) => ({
      ...m,
      material: materials.find((mat) => mat.id === m.materialId)
    }))
    .filter((m) => m.material?.image && m.hideOnDocument !== true)

  if (!itemMaterials.length) return null

  return (
    <>
      <div
        style={{ marginBottom: -10 }}
        className="flex flex-row-reverse
 grid-cols-2 gap-1 w-[35px] h-[35px]"
      >
        {itemMaterials.slice(0, 2).map(({ material }) => (
          <img
            key={material!.id}
            src={material!.image!.url}
            alt={material!.image!.alt}
            className="w-full h-full object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
            onClick={(e) => {
              e.stopPropagation()
              setImageEditorEntity({
                id: item.id,
                materialId: material!.id,
                type: 'material'
              })
            }}
          />
        ))}
      </div>
    </>
  )
}
